<template>
<div>
  <!-- <Navbar /> -->
  <v-container id="policy" style="height: calc(100vh - 170px); overflow-y: scroll; background: white; font-size: 16px; padding: 10px !important;"  class="Kanit">
    <br>
    <h2 style="text-align: center;text-decoration: underline;">{{$t('Settings.policy.header')}}
    </h2>
    <br>
    <h3 class="Kanit">&emsp;&emsp;{{$t('Settings.policy.subject1.header')}}</h3>
    <p class="Kanit" style="padding: 1vw; font-size: 13px;">&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject1.introDetail')}}
      <br>&emsp;&emsp;{{$t('Settings.policy.subject1.subjectIntro1')}}
      <br>&emsp;&emsp;{{$t('Settings.policy.subject1.subjectIntro2')}}
      <br>&emsp;&emsp;{{$t('Settings.policy.subject1.subjectIntro3')}}
      <br>&emsp;&emsp;{{$t('Settings.policy.subject1.subjectIntro4')}}
      <br>&emsp;&emsp;{{$t('Settings.policy.subject1.subjectIntro5')}}
      <br>&emsp;&emsp;{{$t('Settings.policy.subject1.subjectIntro6')}}
      <br>&emsp;&emsp;{{$t('Settings.policy.subject1.subjectIntro7')}}
      <br>&emsp;&emsp;{{$t('Settings.policy.subject1.subjectIntro8')}}
    </p>
    <h3 class="Kanit">&emsp;&emsp;{{$t('Settings.policy.subject2.header')}}</h3>
    <p class="Kanit" style="padding: 1vw;font-size: 13px;"> <b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject2.subHeaderScopeA')}}</b>
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject2.detailScopeA1')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject2.detailScopeA2')}}<br>
      <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject2.subHeaderScopeB')}}</b>
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject2.detailScopeB1')}}
    </p>
    <h3 class="Kanit">&emsp;&emsp;{{$t('Settings.policy.subject3.header')}}</h3>
    <p class="Kanit" style="padding: 1vw; font-size: 13px;"><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subHeaderTypeA')}}</b>
      &emsp;{{$t('Settings.policy.subject3.detailSubHeaderA')}}
      <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subjectA1')}}</b>
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectA1')}}
      <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subjectA2')}}</b>
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectA2')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectA21')}}<br>
      <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subHeaderTypeB')}}</b>
      &emsp;{{$t('Settings.policy.subject3.detailSubHeaderB')}}
      <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subjectB1')}}</b>
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB1')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB12')}}
      <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subjectB2')}}</b>
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB2')}}
      <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subjectB3')}}</b>
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB3')}}
      <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subjectB4')}}</b>
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB41')}}
      <br>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB42')}}
      <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subjectB5')}}</b>
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB51')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB52')}}

      <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subjectB6')}}</b>
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB6')}}
        <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subjectB7')}}</b>
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB71')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB72')}}

      <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subjectB8')}}</b>
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB8')}}

      <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.subjectB9')}}</b>
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB91')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject3.detailSubjectB92')}}
       
      <br></p>
    <h3 class="Kanit">&emsp;&emsp;{{$t('Settings.policy.subject4.header')}}</h3>
    <p class="Kanit" style="font-size: 13px; padding: 1vw;"><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.subjectA')}}</b>
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectA')}}


      <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA1')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA2')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA3')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA4')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA5')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA6')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA7')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA8')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA9')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA10')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA11')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA12')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA13')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA14')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectA15')}}

      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectA16')}}

       <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.subjectB')}}</b>
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectB1')}}

      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectB2')}}

      <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.subjectC')}}</b>
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectC')}}
       <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.subjectD')}}</b>
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectD1')}}
      <br>&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectD2')}}
      <br>&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectD3')}}
      <br>&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectD4')}}
      <br>&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectD5')}}
      <br>&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectD6')}}
      <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.subjectE')}}</b>
      <br> &emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectE')}}
       <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.subjectF')}}</b>
      <br> &emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectF')}}
      <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.subjectG')}}</b>
      <br> &emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectG1')}}
      <br> &emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectG2')}}
      <br> &emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectG3')}}
      <br> &emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectG4')}}
      <br> &emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectG5')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectG6')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject4.detailSubjectG7')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectG8')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject4.detailSubjectG9')}}
      <br></p>
    <h3 class="Kanit">&emsp;&emsp;{{$t('Settings.policy.subject5.header')}}</h3> 
    <p class="Kanit" style="padding: 1vw; font-size: 13px;">&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject5.detailHeader')}}
        <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject5.subjectA')}}</b>
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject5.detailSubjectA')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject5.detailSubjectA1')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject5.detailSubjectA2')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject5.detailSubjectA3')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject5.detailSubjectA4')}}
       <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject5.subjectB')}}</b>
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject5.detailSubjectB')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject5.detailSubjectB1')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject5.detailSubjectB2')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject5.detailSubjectB3')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;• {{$t('Settings.policy.subject5.detailSubjectB4')}}
      <br></p>
    <h3 class="Kanit">&emsp;&emsp;{{$t('Settings.policy.subject6.header')}}</h3>
    <p class="Kanit" style="padding: 1vw; font-size: 13px;"><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject6.subjectA')}}</b>
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject6.detailSubjectA')}}
      <br><b>&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject6.subjectB')}}</b>
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject6.detailSubjectB1')}}
      <br>&emsp;&emsp;&emsp;&emsp;&emsp;{{$t('Settings.policy.subject6.detailSubjectB2')}}

      <br></p>
    <br>
  </v-container>
  <!-- mobile -->
<!--   <v-card-text class="hidden-md-and-up">
    <PolicyMobile />
  </v-card-text> -->
  <!-- <Footer/> -->
</div>
</template>

<script>
// import Navbar from '@/components/homepage/Navbar'
// import Footer from '@/components/homepage/Footer'
// import PolicyMobile from '@/components/mobile/settings/PolicyMobile'
// import Footer from '@/components/home/Footer'
export default {
  components: {
    // Navbar,
    // Footer,
    // PolicyMobile
    // ,Footer
  },
  created () {
    // this.$i18n.locale = 'th'
    this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
  },
  methods: {
    linkAPI() {
      window.open('/docs', '_blank').focus()
    },
    toPage(page) {
      this.$router.push(page)
    },
    linkregister() {
      window.open('/register').focus()
    },
    linkdownload() {
      window.open('/download').focus()
    }
  }
}
</script>

<style type="text/css" scoped>
.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}
.Kanit {
  font-family: 'Kanit' !important;
  word-wrap: break-word;
}

a:link {
  text-decoration: none;
  color: white !important;
}

a:visited {
  color: white !important;
  text-decoration: none;
}

a:hover {
  color: #00afff !important;
  text-decoration: none;
}

a:active {
  color: white !important;
  text-decoration: none;
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: black !important;
  color: white;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/consent/Policy.vue